module.exports = __webpack_public_path__ + "0465b7d8ac240d74f0aa4c64fb16fad4.fbx";